export default function currencyFieldConverter (value, maxDecimalPoints, minus) {
  let currencyValue = {
    number: 0,
    text: ''
  }
  let text = '0.00'

  let dotted = false
  let oneZero = false
  let twoZero = false

  value = value.replace(/[,]/g, '.').replace(/[^0-9.]/g, '')

  if (value.match(/.00/)) {
    twoZero = true
  } else if (value.match(/.0/)) {
    oneZero = true
  } else if (value.match(/[.]/)) {
    dotted = true
  }

  if ((value % 1) !== 0) {
    var decimals = value.toString().split('.')[1].length
  } else {
    decimals = 0
  }

  if (decimals > maxDecimalPoints) {
    text = parseFloat(value).toFixed(maxDecimalPoints)
  } else {
    text = parseFloat(value).toFixed(decimals)
  }

  if (decimals === 0) {
    if (dotted) {
      text = text + '.'
    } else if (oneZero) {
      text = text + '.0'
    } else if (twoZero) {
      text = text + '.00'
    }
  }

  if (!isNaN(text)) {
    currencyValue.number = parseFloat(text)
    currencyValue.text = text
  }

  return currencyValue
}
